import PropTypes from 'prop-types';
import React from 'react';
import { LongTextInput as ReactAdminLongTextInput, required as requiredFn } from 'react-admin';

export const LongTextInput = ({ isRequired, validate, ...props }) => (
  <ReactAdminLongTextInput
    validate={isRequired ? requiredFn() : validate}
    {...props}
  />
)

LongTextInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  validate: PropTypes.func,
};

LongTextInput.defaultProps = {
  sort: false,
  sortable: false,
  alwaysOn: true,
  fullWidth: true
};

export default LongTextInput;

